import Vue from 'vue'

export default {
  UPDATE_PERMISSIONS (state, permissions) {
    state.permissions = permissions
  }
}

